// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__26Ymi","requiredAsterisk":"Info_requiredAsterisk__22R8E"};